import NfeService from "@/services/NfeService";
import NFCeService from "@/services/NFCeService";
import store from "@/store";

export const actions = {
  setGerarNfe: ({ commit, dispatch }) => {
    commit("setNfe", {
      venda_id: "",
      cfop: "5.102",
      informacao_complementar: "",
      tipo_operacao: 1,
      tipo_frete: 9,
      transportadora_id: "",
    });
  },

  setGerarNfce: ({ commit, dispatch }) => {
    commit("setNfce", {
      cfop: store.getters.getEmpresaSelecionada.cfop_padrao_nfce,
      cpf_cnpj: store.getters.getVenda.cliente
        ? store.getters.getVenda.cliente.cpf_cnpj
        : "",
    });
  },

  gerarNfe: ({ commit, dispatch, getters }, data) => {
    commit("setOverlay", true);
    NfeService.gerar(data)
      .then((res) => {
        console.log(res.data)
        commit('setVenda', {...getters.getVenda, chave_nfe: res.data.chave_nfe});
        commit("setModalPrint", res.data.pdf_link);
        commit("snackbarSuccess", "NF-e gerada com sucesso.");
        // dispatch('setModalVisualizarVenda', false)
        dispatch("setModalGerarNfe", false);
        commit("setVenda", {
          ...store.getters.getVenda,
          estado_nfe: "APROVADO",
        });
        dispatch('listarVenda', {
          limit: 20,
          page: 1,
          content: "json"
        })
        commit("setOverlay", false);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e)
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        } else if(e.response.data.errors) {
          commit(
            "alertError",
            e.response.data.erros
          );
        }else{
          commit(
            "alertError",
            [e.response.data.message]
          );
        }
      });
  },

  gerarNFCe: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    NFCeService.gerar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarSuccess", "NFC-e gerada com sucesso.");
        dispatch("setModalGerarNfce", false);
        commit("setVenda", {
          ...store.getters.getVenda,
          estado_nfce: "APROVADO",
        });
        commit("setModalPrint", res.data.pdf_link);
        dispatch('listarVenda', {
          limit: 20,
          page: 1,
          content: "json"
        })
      })
      .catch((e) => {
        commit("setOverlay", false);
        if (e.response.status && e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        } else if(e.response.data.errors) {
          commit(
            "alertError",
            e.response.data.erros
          );
        }else{
          commit(
            "alertError",
            [e.response.data.message]
          );
        }
      });
  },

  async cancelarNfe({commit, dispatch}, data){
    commit('setOverlay', true);
    await NfeService.cancelar(data)
    .then(res => {
      commit('setOverlay', false);
      dispatch('setModalCancelarNfe', false)
      dispatch('listarVenda')
      commit('setVenda', {...store.getters.getVenda, situacao_nfe: 'CANCELADO'})
      commit('snackbarSuccess', res.data.retEvento.infEvento.xMotivo)
    })
    .catch((e) => {
      
      if(e.response.status == 422) {
        commit("alertError", e.response.data.errors);
      }

      commit('setOverlay', false);
      commit('snackbarError', e.response.data.retEvento.infEvento.xMotivo)
    })
  },

  async cancelarNfce({commit, dispatch}, data){
    commit('setOverlay', true);
    await NFCeService.cancelar(data)
    .then(res => {
      commit('setOverlay', false);
      dispatch('setModalCancelarNfce', false)
      dispatch('listarVenda')
      commit('setVenda', {...store.getters.getVenda, situacao_nfce: 'CANCELADO'})
      commit('snackbarSuccess', res.data.retEvento.infEvento.xMotivo)
    })
    .catch((e) => {

      if(e.response.status == 422) {
        commit("alertError", e.response.data.errors);
      }

      commit('setOverlay', false);
      commit('snackbarError', e.response.data.retEvento.infEvento.xMotivo)
    })
  },

  estonarNfe({commit, dispatch}, data){
    commit('setOverlay', true)
    NfeService.estornar(data)
    .then(res => {
      commit('setOverlay', false)
      commit('snackbarSuccess', 'NF-e gerada com sucesso.');
      commit("setModalPrint", res.data.pdf_link);
    })
    .catch(e => {
      if(e.response.status == 422) {
        commit("alertError", e.response.data.errors);
      }
      commit('setOverlay', false)
      commit('snackbarError', 'Erro ao gerar NF-e.')
      console.log(e)
    })
  },

  imprimirNfe: ({ commit, dispatch }, chave_nfe) => {
    commit("setOverlay", true);
    NfeService.imprimir(chave_nfe)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao imprimir NF-e");
        console.log(e);
      });
  },

  imprimirNFCe: ({ commit, dispatch }, venda_id) => {
    commit("setOverlay", true);
    NFCeService.imprimir(venda_id)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao imprimir NFC-e");
        console.log(e);
      });
  },

  setModalGerarNfe: ({ commit, dispatch }, status) => {
    dispatch("setGerarNfe");
    commit("setModalGerarNfe", false);
    setTimeout(() => {
      commit("setModalGerarNfe", status);
    }, 100);
  },
  setModalCancelarNfe: ({ commit, dispatch }, status) => {
    commit("setModalCancelarNfe", false);
    setTimeout(() => {
      commit("setModalCancelarNfe", status);
    }, 100);
  },
  setModalCancelarNfce: ({ commit, dispatch }, status) => {
    commit("setModalCancelarNfce", false);
    setTimeout(() => {
      commit("setModalCancelarNfce", status);
    }, 100);
  },
  setModalGerarNfce: ({ commit, dispatch }, status) => {
    dispatch("setGerarNfce");
    commit("setModalGerarNfce", false);
    setTimeout(() => {
      commit("setModalGerarNfce", status);
    }, 100);
  },
  exportarXmlNfe: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    NfeService.exportarXml(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarSuccess", "Notas enviadas.");
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao enviar notas.");
      });
  },
  gerarCartaCorrecaoNfe: ({commit, dispatch}, data) => {
    commit('setOverlay', true);
    NfeService.gerarCartaCorrecao(data)
    .then(res => {
      commit('setOverlay', false);
      commit("setModalPrint", res.data.impressao.pdf_link);
      store.getters.getVenda.cartas_correcao.push(res.data.carta)
      
      dispatch('listarVenda', {
        limit: 20,
        page: 1,
        content: "json"
      })
      
    })
    .catch(e => {
      commit('setOverlay', false)
      if(e.response.status == 422) {
        commit("alertError", e.response.data.errors);
      }
      console.log(e)

    })
  },
  imprimirCartaCorrecao: ({commit, dispatch}, data) => {
    commit('setOverlay', true)
    NfeService.imprimirCartaCorrecao(data)
    .then(res => {
      commit('setOverlay', false)
      commit("setModalPrint", res.data.pdf_link);
    })
    .catch(e => {
      console.log(e)
      commit('snackbarError', 'Erro ao imprimir CC-e')
    })
  },  
  gerarRelatorioNfe: ({ commit }, data) => {
    commit("setOverlay", true);
    NfeService.relatorio(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao emitir relatório.");
      });
  },

  gerarRelatorioNfce: ({ commit }, data) => {
    commit("setOverlay", true);
    NFCeService.relatorio(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao emitir relatório.");
      });
  },

  setModalEnviarNfeEmail({ commit }, payload) {
    commit("setModalEnviarNfeEmail", false);
    setTimeout(() => {
      commit("setModalEnviarNfeEmail", payload);
    }, 100);
  },
 
  enviarNfeEmail({ commit, dispatch }, data) {
    commit("setOverlay", true);
    NfeService.enviarEmail(data)
      .then((res) => {
        dispatch("setModalEnviarNfeEmail", false)
        commit("setOverlay", false);
        commit("snackbarSuccess", "Nota enviada com sucesso.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  setModalEstornoNfe({commit, dispatch}, status){
    commit('setModalEstornoNfe', false)
    setTimeout(() => {
      commit("setModalEstornoNfe", status);
    }, 100);
  },
  setModalCartaCorrecaoNfe({ commit }, payload) {
    commit("setModalCartaCorrecaoNfe", false);
    setTimeout(() => {
      commit("setModalCartaCorrecaoNfe", payload);
    }, 100);
  },

};

export default {};
